// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// css
import '../../scss/pages/page-about.scss';

// utils
import foundation from '../_utils/foundation';
import Ease from '../_utils/Ease';
foundation();

document.addEventListener('DOMContentLoaded', () => {
	const $fv = document.querySelector('.js-fv');
	if ($fv) {
		const $headline = $fv.querySelector('.js-fv-headline');
		const $headlineEn = $headline.querySelector('.js-fv-headline-en');
		const $headlineJa = $headline.querySelector('.js-fv-headline-ja');
		const $enChar = $headlineEn.querySelectorAll('.char');

		function fvAnimation() {
			gsap.set($headline, {
				opacity: 1,
			});

			gsap.fromTo(
				$enChar,
				{
					display: 'inline-block',
					yPercent: 101,
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					stagger: 0.032,
				}
			);

			gsap.fromTo(
				$headlineJa,
				{
					yPercent: 101,
					display: 'inline-block',
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					delay: 0.4,
				}
			);
		}

		setTimeout(() => {
			fvAnimation();
		}, 400);
	}
});

window.addEventListener('load', () => {});
